const getPropDefaults = (module) => {
  const { props: selfProps, extends: extendedModule } = module;
  const propDefaults = {};
  let props = { ...selfProps };

  if (extendedModule && extendedModule.props) {
    props = { ...selfProps, ...extendedModule.props };
  }

  if (Array.isArray(props)) {
    props.forEach((key) => {
      propDefaults[key] = undefined;
    });
  } else {
    // TODO: Remove prop defaults as initial data so it doesn't save
    // instanceId or other not data related props
    delete props.instanceId;

    Object.keys(props).forEach((key) => {
      // Don't set menu links default in instance data so it can start with undefined on properties
      // And still deal with it as an array inside the component without much refactor
      // This is done so we can have an default custom menu input without saving it in database
      if (key !== 'menuLinks' || module.name.includes('Global')) {
        if (typeof props[key].default === 'function') {
          propDefaults[key] = props[key].default.call();
        } else {
          propDefaults[key] = props[key].default;
        }
      }
    });
  }

  return propDefaults;
};

module.exports = getPropDefaults;
